import React from 'react';
import Loader from '../../../../common/loader';

function DisplayLoader(props) {
  return <div>{props.displayLoader ? <Loader /> : props.children}</div>;
}

export default DisplayLoader;



// WEBPACK FOOTER //
// ./src/views/CFA3/Cfa3EssayQuestions/Layout/DisplayLoader.jsx